<template>
  <div class="racontrols">
    <StudyEvConverterSwitcher />
    <ReportsViewSwitcher :street />
  </div>
</template>

<script>
import ReportsViewSwitcher from '@/components/Switchers/ReportsViewSwitcher'
import StudyEvConverterSwitcher from '@/components/Switchers/StudyEvConverterSwitcher'

export default {
  name: 'StudyControlsReports',
  components: {
    ReportsViewSwitcher,
    StudyEvConverterSwitcher,
  },
  props: {
    street: { default: () => 'flop' },
  },
}
</script>
<style lang="scss" scoped>
.racontrols {
  display: flex;
  gap: 0.25rem;
  padding: 0 0.25rem;
  background: var(--clr-black-1);
  border-radius: 6px;
  align-items: center;
  justify-content: center;
  max-height: 1.65rem;
}
</style>
